import { Api } from 'utils';

class BannerService {
	
	static admin = {
		get: async (params?: any) => Api.createResponse('admin/banners',params),
		save: async (params?: any) => Api.createResponse('admin/banners/save',params),
	}

}

export default BannerService;